'use client';

import { cn } from '../_lib/utils';
import { Container, type ContainerProps } from '../Container';
import { TextSectionBlock, TextSectionBlockProps } from '../TextSectionBlock';
import { Stat, StatisticProps } from '../Stat';

export type StatsProps = {
	className?: string;
	stickyTitle?: boolean;
	textSectionBlock?: Omit<TextSectionBlockProps, 'size'>;
	items?: Pick<StatisticProps, 'label' | 'value' | 'description'>[];
	size?: ContainerProps['size'];
};

export function Stats(props: StatsProps) {
	const stickyTitle = props.stickyTitle ?? false;

	return (
		<section className={props.className} data-component='Stats'>
			<Container
				className={cn('flex flex-col gap-responsive-2xl', stickyTitle ? 'lg:grid lg:grid-cols-2 lg:gap-responsive-5xl lg:items-start' : '')}
				size={props.size}
			>
				{props.textSectionBlock && (
					<div className={cn('max-w-max-sm', stickyTitle ? 'lg:sticky lg:top-[var(--header-offset,0)]' : '')}>
						{props.textSectionBlock && <TextSectionBlock size='md' {...props.textSectionBlock} />}
					</div>
				)}

				{props.items && props.items.length > 0 && (
					<div
						className={cn(
							'grid gap-responsive-lg grid-cols-1 md:grid-cols-2',
							stickyTitle ? 'lg:grid-cols-1' : props.size === 'editorial-wide' ? 'lg:grid-cols-2' : 'lg:grid-cols-3',
						)}
					>
						{props.items.map((item, i) => (
							<Stat key={i} size='medium' {...item} />
						))}
					</div>
				)}
			</Container>
		</section>
	);
}
